import { render, staticRenderFns } from "./UserProfileCardForm.vue?vue&type=template&id=c5f9fb42"
import script from "./UserProfileCardForm.vue?vue&type=script&lang=js"
export * from "./UserProfileCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports